import { deriveCredential } from '@trustvc/w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const deriveW3C = /* @__PURE__ */ __name(async (credential, revealedAttributes) => {
  return deriveCredential(credential, revealedAttributes);
}, "deriveW3C");

export { deriveW3C };
